import { useQuery } from '@tanstack/react-query';
import { rollReviewPricingRepository } from '../repositories/rollReviewPricingRepository';
import type { RollReviewPricing } from '../domain/rollReviewPricing';

export interface UseInstructorPricingQueryReturn {
  pricing: RollReviewPricing | null;
  isLoading: boolean;
  error: string | null;
}

export function useInstructorPricingQuery(
  instructorId: string | undefined,
): UseInstructorPricingQueryReturn {
  const {
    data: pricing,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['instructor-pricing', instructorId],
    queryFn: () => rollReviewPricingRepository.fetchByInstructorId(instructorId ?? ''),
    enabled: !!instructorId,
  });

  return {
    pricing: pricing ?? null,
    isLoading,
    error: error ? String(error) : null,
  };
}
